import HttpClient from "@/api/utils/HttpClient"

export const messagesApiClient = HttpClient({
  baseURL: import.meta.env.SO_MESSAGES_URL,
})
